import type { EnrollmentCredentialModel } from '@/adapters/apiv1.g';
import type {
  EnrollmentCredential,
  EnrollmentCredentialKind,
} from '@/types/core/enrollment';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend EnrollmentCredentialModel to the frontend type.
 * Handles snake_case to camelCase conversion and provides safe defaults.
 */
export function extractEnrollmentCredential(
  model: EnrollmentCredentialModel
): EnrollmentCredential {
  return {
    credentialId: (model.credential_id ?? '') as UUID,
    tenantId: (model.tenant_id ?? '') as UUID,
    kind: (model.kind ?? 'join_code') as EnrollmentCredentialKind,
    name: model.name ?? '',
    capabilities: model.capabilities ?? [],
    groups: model.groups ?? [],
    roleIds: (model.role_ids ?? []) as UUID[],
    useCount: model.use_count ?? 0,
    isRevoked: model.is_revoked ?? false,
    createdBy: model.created_by ?? '',
    expiresAt: model.expires_at ?? '',
    lastUsedAt: model.last_used_at ?? '',
    revokedAt: model.revoked_at ?? '',
    revokedBy: model.revoked_by ?? '',
  };
}
